import { AcqPayment } from '../../types.ts'
import { AcqOperationType, AcqPaymentStatus, Amount, DataRow, Text } from '../../components'

export const MAIN_INFO_LABELS: Array<DataRow<AcqPayment>> = [
  { key: 'type', label: 'Тип операции', renderer: AcqOperationType },
  { key: 'date', label: 'Время оплаты', renderer: Text },
  { key: 'state', label: 'Статус', renderer: AcqPaymentStatus },
  { key: 'additionalIdentifier', label: 'Доп. идентификатор', renderer: Text },
]

export const MONEY_INFO_LABELS: Array<DataRow<AcqPayment>> = [
  { key: 'amount', label: 'Сумма', renderer: Amount },
  { key: 'amountReturn', label: 'Сумма возврата', renderer: Amount },
  { key: 'comissionPayer', label: 'Комиссия с клиента', renderer: Amount },
  { key: 'comissionReceiver', label: 'Комиссия с магазина', renderer: Amount },
  { key: 'amountIncomeClient', label: 'Сумма к зачислению клиенту', renderer: Amount },
  { key: 'amountIncomeMerchant', label: 'Сумма к зачислению магазину', renderer: Amount },
]

export const CLIENT_INFO_LABELS: Array<DataRow<AcqPayment>> = [
  { key: 'clientFio', label: 'ФИО клиента', renderer: Text },
  { key: 'clientEmail', label: 'E-mail', renderer: Text },
]

export const CARD_INFO_LABELS: Array<DataRow<AcqPayment>> = [
  { key: 'accountNumber', label: 'Счёт зачисления', renderer: Text },
  { key: 'bankIssuer', label: 'Эмитент карты', renderer: Text },
  { key: 'bankIssuerCountry', label: 'Страна эмитента', renderer: Text },
  { key: 'cardType', label: 'Тип карты', renderer: Text },
  { key: 'pan', label: 'Номер карты', renderer: Text },
]
